import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { MyDatePickerModule } from 'mydatepicker';

import { CampaignRoutingModule } from './campaign-routing.module';
import { CampaignListComponent } from './components/campaign-list.component';
import { CampaignDetailComponent } from './components/campaign-detail.component';
import { CampaignEditComponent } from './components/campaign-edit.component';
import { CampaignMenuComponent } from './components/campaign-menu.component';
import { CampaignStatisticComponent } from './components/campaign-statistic.component';
import { CampaignService } from './campaign.service';

import { LinkModule } from '../links/link.module';
import { CounterModule } from '../counters/counter.module';
import { AgentModule } from '../agents/agent.module';
import { StatisticModule } from '../statistics/statistic.module';

import { CampaignErrorBlockComponent } from '../errors/error.component';
import { ErrorService } from '../errors/error.service';
import { SharedModule } from '../shared/module';

@NgModule({
  imports: [
    BrowserModule,
    CampaignRoutingModule,
    MyDatePickerModule,
    LinkModule,
    CounterModule,
    StatisticModule,
    AgentModule,
    SharedModule
  ],
  declarations: [
    CampaignListComponent,
    CampaignEditComponent,
    CampaignDetailComponent,
    CampaignMenuComponent,
    CampaignStatisticComponent,
    CampaignErrorBlockComponent
  ],
  exports: [],
  providers: [
    ErrorService,
    CampaignService
  ],
})
export class CampaignModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/campaigns/campaign.module.ts